import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { keypressValidateNumber, formatNumber } from 'src/app/common/helper';
import { MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatAutocompleteTrigger } from '@angular/material';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { Observable } from 'rxjs';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard/dashboard.service';
import { startWith, map } from 'rxjs/operators';
import { AlertMessageComponent } from 'src/app/modules/shared/components/alert-message/alert-message.component';
import { LaboratoryWorksService } from '../../../service/laboratory-works/laboratory-works.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

export interface Patient {
  id: number;
  firstName: string;
  middleName: string;
  lastName: string;
}

@Component({
  selector: 'ark-edit-lab-works',
  templateUrl: './edit-lab-works.component.html',
  styleUrls: ['./edit-lab-works.component.scss']
})
export class EditLabWorksComponent implements OnInit {
  
  today = new Date(); 
  datePipe = new DatePipe('en-US');
  errorMessage = null;
  clinic = '';
  loading: boolean = false;
  dialogConfig = new MatDialogConfig();
  formGroup: FormGroup;
  patientControl = new FormControl();
  patients: Patient[] = [];
  filteredPatients: Observable<Patient[]>;
  purposes = [
    { id: 1, name: 'Payment' },
    { id: 2, name: 'Pick-up' },
    { id: 3, name: 'Delivery' }
  ];
  patientId = null;
  patientName = null;
  date = null;
  @ViewChild('patient') patient: MatAutocompleteTrigger;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditLabWorksComponent>,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private dashboard: DashboardService,
    private laboratory: LaboratoryWorksService
  ) { 
    this.clinic = this.auth.getAuthUser().user_clinic.id;
    this.date = moment(this.data.data.date).format("YYYY-MM-DD");
    this.dashboard.getPatientList(this.clinic, this.clinic).subscribe(res => {
      res.data.forEach(element => {
        let obj: Patient = {
          id: element.id, 
          firstName: element.first_name, 
          middleName: element.middle_name ? element.middle_name : '', 
          lastName: element.last_name
        };
        this.patients.push(obj);
      });
    });
    this.formGroup = this.formBuilder.group({
      date: [''],
      patient_id: [''],
      case: [''],
      amount: [''],
      lab_name: [''],
      cheque_no: [''],
      purpose: [''],
      messenger: [''],
      received_by: ['']
    });
  }

  ngOnInit() {
    console.log(this.data);
    this.dialogConfig.disableClose = true;
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';
    this.filteredPatients = this.patientControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterPatient(name) : this.patients.slice()),
      );
    this.formGroup.get('date').setValue(this.date);
    if(this.data.data.patient){
      this.patientControl.setValue(
        {
          id: this.data.data.patient.id, 
          firstName: this.data.data.patient.first_name, 
          middleName: this.data.data.patient.middle_name, 
          lastName: this.data.data.patient.last_name
        }
      );
    }
    this.patientId = this.data.data.patient ? this.data.data.patient.id : null;
    this.formGroup.get('case').setValue(this.data.data.case);
    this.formGroup.get('amount').setValue(formatNumber(this.data.data.amount));
    this.formGroup.get('lab_name').setValue(this.data.data.lab_name);
    this.formGroup.get('cheque_no').setValue(this.data.data.cheque_no);
    this.formGroup.get('purpose').setValue(this.data.data.purpose);
    this.formGroup.get('messenger').setValue(this.data.data.messenger);
    this.formGroup.get('received_by').setValue(this.data.data.received_by);
  }

  displayPatient(patient?: any) : string | undefined {
    return patient ? patient.lastName + ', ' + patient.firstName + ' ' + (patient.middleName ? patient.middleName : '') : undefined;
  }

  private _filterPatient(name: string): Patient[] {
    const filterValue = name.toLowerCase();
    return this.patients.filter(option => option.lastName.toLowerCase().indexOf(filterValue) > -1 || option.firstName.toLowerCase().indexOf(filterValue) > -1 || option.middleName.toLowerCase().indexOf(filterValue) > -1);
  }

  onFocusPatient() {
    this.patient._onChange("");
    this.patient.openPanel();
  }

  getPatient(event) {
    this.patientId = event.option.value.id;
    this.patientName = event.option.value.firstName + ' ' + (event.option.value.middleName ? event.option.value.middleName + ' ' : '') + event.option.value.lastName;
  }

  getVisitorName(e) {
    this.patientName = e;
  }

  updateLabWorks() {
    let date = this.datePipe.transform(this.formGroup.value.date, 'yyyy-MM-dd');
    let data = {
      user_clinic_id: this.clinic,
      date: date,
      patient_id: this.patientId,
      case: this.formGroup.value.case,
      amount: +this.formGroup.value.amount ? +this.formGroup.value.amount : this.data.data.amount,
      lab_name: this.formGroup.value.lab_name,
      cheque_no: this.formGroup.value.cheque_no,
      purpose: this.formGroup.value.purpose,
      messenger: this.formGroup.value.messenger,
      received_by: this.formGroup.value.received_by,
      user_id: this.auth.getAuthUser().id
    }
    this.laboratory.updateLabWork(this.data.data.id, data).subscribe(res => {
      if(res) {
        this.dialogRef.close(res);
        this.dialogConfig.data = {
          title: 'Success!',
          message: 'Clinic log has been successfully updated.',
          button: 'Okay',
          event: this.close
        };
        let dialogRef = this.dialog.open(AlertMessageComponent, this.dialogConfig);
      }
    },(err => {
      this.dialogConfig.data = {
        title: 'Oops!',
        message: err.error.message,
        button: 'Okay',
        event: this.close
      };
      let dialogRef = this.dialog.open(AlertMessageComponent, this.dialogConfig);
      this.errorMessage = err.error.errors;
      this.triggerErrors(err.error.errors);
    }));
  }

  triggerErrors(err){
    Object.keys(this.formGroup.controls).forEach(key => {
      if (err[key]) {
        this.formGroup.controls[key].setErrors({'invalid': true});
        this.formGroup.controls[key].markAsTouched();
        this.formGroup.controls[key].markAsDirty();
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  numberTypeValidation(e) {
    return keypressValidateNumber(e);
  }

  formatNumber(num) {
    return formatNumber(num);
  }
}
